/** Shopify CDN: Minification failed

Line 61:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 62:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 95:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 105:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 112:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 115:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 118:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 122:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 123:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 124:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 46:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 47:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 80:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 90:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 97:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 100:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 103:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 107:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 108:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 109:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 32:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 65:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 75:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 82:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 85:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 88:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 92:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 93:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 94:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 17:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 50:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 60:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 67:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 70:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 73:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 77:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 78:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 79:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
class CookieBanner extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };
    this.banner = this.querySelector('.cookie-banner');

    if (this.dataset.testMode === 'true') {
      this.init();

      this.querySelectorAll('.button').forEach(
        (button) => button.addEventListener('click', this.close.bind(this))
      );
    }
    else {
      window.Shopify.loadFeatures([
        {
          name: 'consent-tracking-api',
          version: '0.1',
        }
      ],
      (error) => {
        if (error) {
          throw error;
        }
    
        this.beforeInit();
      });
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  onSectionLoad(event) {
    filterShopifyEvent(event, this, () => this.open.bind(this));
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.close.bind(this));
  }

  beforeInit() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

    if (!window.location.pathname.match(/^(\/[a-z]{2}(-[A-Z]{2})?)?\/cart$/) && !userCanBeTracked && userTrackingConsent === 'no_interaction') {
      this.init();

      this.querySelectorAll('.button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  }

  init() {
    if (Shopify && Shopify.designMode) {
      return;
    }

    setTimeout(function() {
      this.open();
    }.bind(this), parseInt(this.dataset.delay) * 1000);
  }

  open() {
    this.banner.classList.add(this.classes.activeClass);
  }

  close() {
    this.banner.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.banner.classList.remove(this.classes.activeClass);
      this.banner.classList.remove(this.classes.closingClass);
    }, 500);
  }

  onButtonClick(event) {
    event.preventDefault();
    this.close();

    if (event.target.name === 'accept') {
      window.Shopify.customerPrivacy.setTrackingConsent(true, this.noop);

      document.addEventListener('trackingConsentAccepted', () => {
        console.log('trackingConsentAccepted event fired');
      });
    }
    else {
      window.Shopify.customerPrivacy.setTrackingConsent(false, this.noop);
    }
  }

  noop() {
  }
}
customElements.define('cookie-banner', CookieBanner);
